import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, watch, computed } from 'vue';
import {
  BaseText,
  ButtonContainer,
  ButtonSecondary,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import ModalCreateWallet from '../../components/Modals/ModalCreateWallet/ModalCreateWallet.vue';
import CardInstrumentSelected from '../Instruments/CardInstrumentSelected.vue';
import { Product } from '../../types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  IDataConfirmEdit,
  IEditPortfolioResponse,
  IProductRemove,
  IProductsRemoveParam
} from '../../services/types/models/IBffInvestments';
import { useRouter } from 'vue-router/composables';

interface Props {
  instruments: Product[];
  isDeleteActive: boolean;
  isEditor: boolean;
  portfolioId?: string;
  isTemplate?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedInstrumentsReview',
  props: {
    instruments: null,
    isDeleteActive: { type: Boolean },
    isEditor: { type: Boolean },
    portfolioId: null,
    isTemplate: { type: Boolean }
  },
  emits: ['show-wallet-selection', 'disable-delete-mode'],
  setup(__props: any, { emit }) {

const props = __props as {
  instruments: Product[];
  isDeleteActive: boolean;
  isEditor: boolean;
  portfolioId?: string;
  isTemplate?: boolean;
};




const removeProductFromWallet = inject(
  'removeProductFromWallet',
  async (params: IProductsRemoveParam) => ({ params })
);

const confirmEditPortfolio = inject(
  'confirmEditPortfolio',
  async (_: IDataConfirmEdit) => ({ name: '' } as IEditPortfolioResponse)
);

watch(
  () => props.instruments,
  (newValue, _) => {
    if (newValue.length === 0) {
      emit('show-wallet-selection');
    }
  }
);

watch(
  () => props.isDeleteActive,
  (newValue, _) => {
    if (!newValue) {
      productSelected.value = [];
    }
  }
);

const router = useRouter();

const productSelected = ref<string[]>([]);

const showWalletModal = ref(false);

const isLoading = ref(false);

const isLoadingRemove = ref(false);

const createWalletButtonLabel = computed(() => {
  return props.isTemplate ? 'Criar carteira modelo' : 'Criar carteira';
});

async function handleConfirmationEvent() {
  if (props.isEditor) {
    isLoading.value = true;

    const result = await confirmEditPortfolio({
      portfolioId: props.portfolioId!
    });

    isLoading.value = false;

    router.replace({
      name: 'wealthWalletEdited',
      params: { id: props.portfolioId ?? '' },
      query: { portfolioname: result?.name || '-' }
    });
  } else {
    showWalletModal.value = !showWalletModal.value;
  }
}

function handleInstrumentSelected({ id }: IProductRemove) {
  if (props.isDeleteActive) {
    if (productSelected.value.includes(id)) {
      productSelected.value = productSelected.value.filter(item => item !== id);
    } else {
      productSelected.value.push(id);
    }
  }
}

async function handleDeleteProduct() {
  try {
    isLoadingRemove.value = true;
    await removeProductFromWallet({ productIds: productSelected.value });
  } finally {
    emit('disable-delete-mode');
    isLoadingRemove.value = false;
  }
}

return { __sfc: true,props, emit, removeProductFromWallet, confirmEditPortfolio, router, productSelected, showWalletModal, isLoading, isLoadingRemove, createWalletButtonLabel, handleConfirmationEvent, handleInstrumentSelected, handleDeleteProduct, BaseText, ButtonContainer, ButtonSecondary, ButtonPrimary, ModalCreateWallet, CardInstrumentSelected, NebraskaColors }
}

})